import {MemberSignboardRepo} from './MemberSignboardRepo'
import {CommonResponseDTO, CommonResponseJSON} from '../../Network/CommonResponse'
import FetchWrapper from '../../Network/FetchWrapper'
import {withMembersAuth} from '../../Network/BrowserFetchWrapper'
import {SignedUpSignboardDTO, SignedUpSignboardJSON} from '../DTO/SignedUpSignboardDTO'

export class NetworkMemberSignboardRepo implements MemberSignboardRepo {
  private serverUrl = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_SERVER_URL

  constructor(private fetchWrapper: FetchWrapper) {
  }

  getSignedUpSignboards(): Promise<CommonResponseDTO<SignedUpSignboardDTO[]>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/m/r/members/self/signboards`,
      withMembersAuth(),
    ).then((json: CommonResponseJSON<SignedUpSignboardJSON[]>) =>
      CommonResponseDTO.fromArray(json, SignedUpSignboardDTO.fromJSON))
  }
}
